const initCareerFilters = function initCareerFilters()
{
  const team = document.getElementById('career-team');
  const employment = document.getElementById('career-employment');
  const items = document.querySelectorAll('#career-list a');

  if( team && employment && items.length > 0 ) {
    team.addEventListener('change', filterCareers);
    employment.addEventListener('change', filterCareers);
  }

  function filterCareers() {
    items.forEach( item => {
        item.classList.remove('hidden');

        if( team.value !== 'all' && !item.dataset.team.includes(team.value) ) {
            item.classList.add('hidden');
        }
        if( employment.value !== 'all' && !item.dataset.employment.includes(employment.value) ) {
            item.classList.add('hidden');
        }
    });
  }
}
export { initCareerFilters };